import discount from '../../fields/shared/discount';

export const MUTATION_UPDATE_DISCOUNT = /* GraphQL */ `
	mutation($id: String!, $input: DiscountUpdate!) {
		updateDiscount(id: $id, input: $input) {
			${discount}
		}
	}
`;
